<template>
  <div
      class="item_wrap"
  >
    <div class="item_top f gray">
      <ItemCardComponentsExteriorAB
          :name="item.market_hash_name"
      />
      <ItemCardComponentsCap
          :price-diffs="item.price_difference || 0"
      />
    </div>
    <div class="item_body">
      <ItemCardComponentsImage
          :item="item as any"
          :loading="loading"
      />
      <ItemCardComponentsName :item="item as any" />
    </div>
    <div class="f item_footer">
      <div class="btn btn-primary fg">
        <img
            v-if="market"
            :alt="market"
            :src="getImageFromProxy(`${imagesUrl}markets/${market}.svg`, '50:50')"
            class="wh24 round mr8"
            height="24"
            loading="lazy"
            width="24"
        />
        <ItemCardComponentsPrice
            :decimal="0"
            :price="item.price || 'suiiii'"
        />
      </div>
    </div>
  </div>
</template>

<script lang="ts" setup>
import type {InventoryItem} from "~/types/InventoryItem";

const props = defineProps<{
  item: InventoryItem,
  loading?: 'lazy' | 'eager'
  market?: string
}>()

const config = useRuntimeConfig()
const imagesUrl = config.public.imagesUrl
</script>

<style lang="scss" scoped>
@use 'sass:color';

.item {
  &_wrap {
    cursor: pointer;
    display: flex;
    flex-direction: column;
    background: var(--surfaces-low-container);
    border-radius: 0.8rem;
    padding: 1.6rem;
    font-size: 1.2rem;
    transition: 0.3s;
    position: relative;
    max-width: 180px;
    height: 100%;

    &:hover,
    &:focus {
      outline: none;
      background: color-mix(in srgb, var(--surfaces-low-container) 98%, white);

      .thumb {
        border-color: color-mix(in srgb, var(--surfaces-low-container) 98%, white);
      }
    }

    .price {
      margin: 1.6rem 0 0.6rem;
      min-height: 2.5rem;
    }
  }

  &_top {
    position: absolute;
    z-index: 1;
    width: 100%;
    top: 0;
    left: 0;
    padding: 1.6rem;
  }

  &_footer {
    margin-top: auto;

    .btn-primary:deep(span) {
      margin-left: 0;
    }
  }
}

.buy_toolbar {
  font-size: 1.2rem;
  margin-top: 1.5rem;

  .btn-primary {
    flex-grow: 1;
    margin-right: 1rem;
  }
}
</style>
